import { Action } from '@/_core/fluxstore/types';
import { ManageProductsState } from '../types';
import { useManageProductsStore } from '../useModule';
import { queryExecutor } from '@/_core/cqrs';
import { InitManageProductsQuery, InitManageProductsResult } from '@/api/manageProducts/queries';
import { mapArrayDtoPropsToCamelCase } from '@/_core/utils/mapDtos';

const { registerMiddleware, registerReducer } = useManageProductsStore();

export class InitManageProducts extends Action<ManageProductsState> {
    public static ACTION_TYPE = 'InitManageProducts';
    public _res: InitManageProductsResult;

    public constructor() {
        super(InitManageProducts.ACTION_TYPE);
    }
}

const middleware = async (state: ManageProductsState, action: InitManageProducts): Promise<boolean> => {
    action._res = await queryExecutor.executeQuery(new InitManageProductsQuery());
    return true;
};

const reducer = (state: ManageProductsState, action: InitManageProducts): void => {
    state.products = mapArrayDtoPropsToCamelCase(action._res.Products);
    state.workspaceMembers = mapArrayDtoPropsToCamelCase(action._res.WorkspaceMembers);
    state.isInitialized = true;
};

//@ts-ignore
registerMiddleware(InitManageProducts.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(InitManageProducts.ACTION_TYPE, reducer);
